import 'ress'

import React from 'react'
import styled, { ThemeProvider } from 'styled-components'

import AwardDescription from '../organisms/AwardDescription'
import Footer from '../organisms/Footer/'
import Header, { LogoVariant } from '../organisms/Header/'
import InstagramCampaign from '../organisms/InstagramCampaign'
import Overlay from '../atoms/Overlay'
import theme from '../theme'
import { GlobalMenuContext, GlobalMenuProvider } from '../contexts/GlobalMenuContext'
import { MysqlCategoriesEdge } from '../graphqlTypes'

const Container = styled.div`
  font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue', 'Segoe UI', sans-serif;
  -webkit-font-smoothing: antialiased;
`

const Main = styled.main`
  @media (min-width: ${({ theme }) => theme.mediaQuery.desktop.minWidth}) {
    padding: 0 180px;
  }
`

const MobileInstagramCampaign = styled(InstagramCampaign)`
  @media (min-width: ${({ theme }) => theme.mediaQuery.desktop.minWidth}) {
    display: none;
  }
`

type Props = {
  children: React.ReactNode
  hideCampaign?: boolean
  hideDescription?: boolean
  logoVariant?: LogoVariant
  menu: MysqlCategoriesEdge[]
}

export default function Layout({ children, hideCampaign, hideDescription, logoVariant, menu }: Props) {
  return (
    <ThemeProvider theme={theme}>
      <GlobalMenuProvider>
        <GlobalMenuContext.Consumer>
          {(openGlobalMenu) => (
            <Container>
              <Header menu={menu} logoVariant={logoVariant} />
              <Main>{children}</Main>
              {!hideCampaign && <MobileInstagramCampaign />}
              {!hideDescription && <AwardDescription />}
              <Footer />
              <Overlay open={openGlobalMenu.state} />
            </Container>
          )}
        </GlobalMenuContext.Consumer>
      </GlobalMenuProvider>
    </ThemeProvider>
  )
}
